__turbopack_context__.v({
  "SCloseButton": "U9Sl9q_SCloseButton",
  "SDialogContent": "U9Sl9q_SDialogContent",
  "SHeading": "U9Sl9q_SHeading",
  "ThemeDk": "U9Sl9q_ThemeDk",
});
